###
VFX Picker Buttons

Status: WIP
###

import FX from ../lib/fx.civet

{ pickerShaders } from ../lib/shaders.civet
{ CUSTOM_PRESET_NAME } from ../const.civet

Jadelet from jadelet

Template := Jadelet.exec """
  aside.fx-picker
    label AFX
    select(value=@afxPresetName)
      @afxPresetOptions
    label VFX
    @items
"""

ItemTemplate := Jadelet.exec """
  button(@click @style @title class=@active)
"""

AFXOptionTemplate := Jadelet.exec """
  option(@value) @name
"""

styleFor := ({name, id}) ->
  if name is "Purple"
    backgroundColor: "#ede7f6"
  else
    backgroundImage: `url(https://danielx.net/composer/fx/shaders/${id}.jpg)`

vfxChoices := pickerShaders

export FXPicker := ({afxPresetName, vfxPresetName, showVFXEditor}) ->
  self :=
    afxPresetName: afxPresetName
    afxPresetOptions: ->
      FX.choices.map (name) ->
        AFXOptionTemplate
          name: name
          value: name

    items: ->
      [
        ItemTemplate
          title: "Edit Shader"
          click: ->
            showVFXEditor()
            vfxPresetName CUSTOM_PRESET_NAME
          style: ->
          active: ->
            "active" if vfxPresetName() is CUSTOM_PRESET_NAME
      ].concat vfxChoices.map (preset) ->
        {name} := preset
        ItemTemplate
          title: name
          click: ->
            vfxPresetName(name)
          style: ->
            styleFor(preset)
          active: ->
            "active" if vfxPresetName() is name

    element: null

  self.element = Template self

  return self

export default FXPicker
